var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrochetPlein(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM18.3364 8.41645C18.5407 8.22077 18.5557 7.88765 18.37 7.67241C18.1842 7.45717 17.868 7.4413 17.6637 7.63698L9.65183 15.3096C9.43833 15.514 9.10531 15.4862 8.92506 15.2489L6.39045 11.9114C6.21795 11.6842 5.9033 11.6474 5.68767 11.8291C5.47204 12.0108 5.43708 12.3423 5.60958 12.5694L8.14419 15.9069C8.68494 16.619 9.68399 16.7024 10.3245 16.089L18.3364 8.41645Z",
    fill: "#01431F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrochetPlein);
export default __webpack_public_path__ + "static/media/crochet-plein.a38dfbfac99a439e98735b21eed201b4.svg";
export { ForwardRef as ReactComponent };